// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4268":"105a234b38efd25b","4647":"481fb509c207b8fd"}[chunkId] + ".js";
};